import React from 'react'
import { Navigate } from 'react-router-dom'
import {
  // student imports
  Students,
  AddStudent,
  EditStudent,
  ViewStudent,
  EditAttendance,

  // driver imports
  Drivers,
  AddDriver,
  EditDriver,

  // Video Categories imports
  AddVideoCategory,
  VideoCategories,

  // Videos imports
  Videos,
  AddVideos,

  // organization imports
  Organizations,
  OrganizationSignup,
  ViewOrganization,
  AddOrganization,
  EditOrganization,
  ViewExpenses,
  OrganizationProfile,
  FuelCardApplication,
  FuelCardApplications,

  // batch imports
  Batches,
  AddBatch,
  EditBatch,
  ViewBatch,

  // expenses imports
  Expenses,
  AddExpense,
  EditExpense,

  // enquiry imports
  Enquiries,
  AddEnquiry,
  EditEnquiry,

  // services imports
  Services,
  AddService,
  EditService,
  ViewService,

  // admins imports
  Admins,
  AddAdmin,

  // dealers imports
  Dealers,
  AddDealer,
  EditDealer,
  DealerProfile,

  // cars imports
  Cars,
  // AddCar,
  // EditCar,

  // bookings imports
  Bookings,

  // commissions imports
  Commissions,

  // invoices imports
  CreateInvoice,

  // agents imports
  AddAgent,
  EditAgent,
  Agents,

  // referrals imports
  Referrals,
  ViewReferral,
} from './Admin'
import NotFound from './NotFound'
// import DownloadPage from "./DownloadPage";
import LoginPage from './LoginPage'
import SignupPage from './SignupPage'
import PrivacyPolicy from './PrivacyPolicy'
import TermsAndConditions from './TermsAndConditions'
import ReferralTermsAndConditions from './ReferralTermsAndConditions'
import About from './About'
import Home from './Home'
import Pricing from './Pricing'
import Contact from './Contact'
import { PROFILES } from '../utils/constants'

const routes = [
  // login and signup routes
  {
    path: '/',
    renderer: (params = {}) => <Home {...params} />,
  },
  {
    path: '/home',
    renderer: (params = {}) => <Home {...params} />,
  },
  {
    path: '/login',
    renderer: (params = {}) => <LoginPage {...params} />,
  },
  {
    path: '/signup',
    renderer: (params = {}) => <SignupPage {...params} />,
  },
  {
    path: '/about',
    renderer: (params = {}) => <About {...params} />,
  },
  {
    path: '/contact',
    renderer: (params = {}) => <Contact {...params} />,
  },
  {
    path: '/pricing',
    renderer: (params = {}) => <Pricing {...params} />,
  },

  // admins routes start
  {
    path: '/admins',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <Admins {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/admins/add',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <AddAdmin {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  // admins routes end

  // student routes
  {
    path: '/students',
    renderer: (params = {}) =>
      params.isAuthenticated === true ? (
        <Students {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/students/add',
    renderer: (params = {}) =>
      params.isAuthenticated === true ? (
        <AddStudent {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/students/view/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true ? (
        <ViewStudent {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/students/edit/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true ? (
        <EditStudent {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/students/attendance/edit/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true ? (
        <EditAttendance {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  // driver routes
  {
    path: '/instructors',
    renderer: (params = {}) =>
      params.isAuthenticated === true ? (
        <Drivers {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/instructors/add',
    renderer: (params = {}) =>
      params.isAuthenticated === true ? (
        <AddDriver {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/instructors/edit/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true ? (
        <EditDriver {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  // organization routes
  {
    path: '/organizations',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <Organizations {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/organizations/signup',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <OrganizationSignup {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/organizations/view/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <ViewOrganization {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/organizations/add',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <AddOrganization {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/organizations/edit/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <EditOrganization {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/organizations/view-expenses/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <ViewExpenses {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/profile',
    renderer: (params = {}) => {
      if (params.isAuthenticated !== true) {
        return <Navigate to="/login" />
      }
      if (params.profile === PROFILES.ORGANIZATION) {
        return <OrganizationProfile {...params} />
      }
      if (params.profile === PROFILES.DEALER) {
        return <DealerProfile {...params} />
      }
      return <Navigate to="/login" />
    },
  },

  // Videos routes
  {
    path: '/videos',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <Videos {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/video/add',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <AddVideos {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  // Video Categories routes
  {
    path: '/video-category',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <VideoCategories {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/video-category/add',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <AddVideoCategory {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  {
    path: '/privacy-policy',
    renderer: (params = {}) => <PrivacyPolicy {...params} />,
  },

  {
    path: '/terms-and-conditions',
    renderer: (params = {}) => <TermsAndConditions {...params} />,
  },

  {
    path: '/referral-terms-and-conditions',
    renderer: (params = {}) => <ReferralTermsAndConditions {...params} />,
  },

  // dealer routes
  {
    path: '/dealers',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <Dealers {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/dealers/add',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <AddDealer {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/dealers/edit/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <EditDealer {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  // cars routes
  {
    path: '/cars',
    renderer: (params = {}) =>
      params.isAuthenticated === true && (params.profile === PROFILES.ADMIN || params.profile === PROFILES.DEALER) ? (
        <Cars {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },


  // bookings routes
  {
    path: '/bookings',
    renderer: (params = {}) =>
      params.isAuthenticated === true && (params.profile === PROFILES.ADMIN || params.profile === PROFILES.DEALER) ? (
        <Bookings {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/payments',
    renderer: (params = {}) =>
      params.isAuthenticated === true && (params.profile === PROFILES.ADMIN  || params.profile === PROFILES.ORGANIZATION) ? (
        <Commissions {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  // batch routes
  {
    path: '/batches',
    renderer: (params = {}) =>
      params.isAuthenticated === true &&
      (params.profile === PROFILES.ADMIN || params.profile === PROFILES.ORGANIZATION) ? (
        <Batches {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/batches/add',
    renderer: (params = {}) =>
      params.isAuthenticated === true &&
      (params.profile === PROFILES.ADMIN || params.profile === PROFILES.ORGANIZATION) ? (
        <AddBatch {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/batches/edit/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true &&
      (params.profile === PROFILES.ADMIN || params.profile === PROFILES.ORGANIZATION) ? (
        <EditBatch {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/batches/view/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true &&
      (params.profile === PROFILES.ADMIN || params.profile === PROFILES.ORGANIZATION) ? (
        <ViewBatch {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  // expenses routes
  {
    path: '/expenses',
    renderer: (params = {}) =>
      params.isAuthenticated === true && (params.profile === PROFILES.ADMIN || params.profile === PROFILES.ORGANIZATION) ? (
        <Expenses {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/expenses/add',
    renderer: (params = {}) =>
      params.isAuthenticated === true && (params.profile === PROFILES.ADMIN || params.profile === PROFILES.ORGANIZATION) ? (
        <AddExpense {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/expenses/edit/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true && (params.profile === PROFILES.ADMIN || params.profile === PROFILES.ORGANIZATION) ? (
        <EditExpense {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  // enquiry routes - organization creates/manages, admin views
  {
    path: '/enquiry',
    renderer: (params = {}) =>
      params.isAuthenticated === true &&
      (params.profile === PROFILES.ORGANIZATION || params.profile === PROFILES.ADMIN) ? (
        <Enquiries {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/enquiry/add',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ORGANIZATION ? (
        <AddEnquiry {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/enquiry/edit/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ORGANIZATION ? (
        <EditEnquiry {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  // services routes - organization creates/manages, admin views
  {
    path: '/services',
    renderer: (params = {}) =>
      params.isAuthenticated === true &&
      (params.profile === PROFILES.ORGANIZATION || params.profile === PROFILES.ADMIN) ? (
        <Services {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/services/add',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ORGANIZATION ? (
        <AddService {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/services/edit/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ORGANIZATION ? (
        <EditService {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/services/view/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true &&
      (params.profile === PROFILES.ORGANIZATION || params.profile === PROFILES.ADMIN) ? (
        <ViewService {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  // fuel card routes
  {
    path: '/fuel-card',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ADMIN ? (
        <FuelCardApplications {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/fuel-card/apply',
    renderer: (params = {}) =>
      params.isAuthenticated === true && params.profile === PROFILES.ORGANIZATION ? (
        <FuelCardApplication {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  // invoices routes
  {
    path: '/invoices/create',
    renderer: (params = {}) =>
      params.isAuthenticated === true &&  params.profile === PROFILES.ORGANIZATION ? (
        <CreateInvoice {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  // agents routes
  {
    path: "/agents",
    renderer: (params = {}) => (params.isAuthenticated === true ? <Agents {...params} /> : <Navigate to='/login' />),
  },
  {
    path: "/agents/add",
    renderer: (params = {}) => (params.isAuthenticated === true ? <AddAgent {...params} /> : <Navigate to='/login' />),
  },
  {
    path: "/agents/edit/:id",
    renderer: (params = {}) => (params.isAuthenticated === true ? <EditAgent {...params} /> : <Navigate to='/login' />),
  },
  // referrals routes
  {
    path: '/referrals',
    renderer: (params = {}) =>
      params.isAuthenticated === true &&
      (params.profile === PROFILES.ADMIN || params.profile === PROFILES.ORGANIZATION) ? (
        <Referrals {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },
  {
    path: '/referrals/view/:id',
    renderer: (params = {}) =>
      params.isAuthenticated === true &&
      (params.profile === PROFILES.ADMIN || params.profile === PROFILES.ORGANIZATION) ? (
        <ViewReferral {...params} />
      ) : (
        <Navigate to="/login" />
      ),
  },

  {
    path: '/*',
    renderer: (params = {}) => <NotFound {...params} />,
  },
]

export default routes
